import { ReactNode } from "react";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  hover?: boolean;
  gradientHeader?: boolean;
}

export function Card({ children, className, title, subtitle, action, hover = false, gradientHeader = false }: CardProps) {
  return (
    <div
      className={cn(
        "bg-white/75 backdrop-blur-xl border border-white/70 rounded-2xl overflow-hidden",
        "transition-all duration-300",
        hover && "hover:-translate-y-0.5 hover:shadow-lg cursor-pointer",
        className
      )}
      style={{
        boxShadow:
          "0 8px 32px 0 rgba(31, 38, 135, 0.08), inset 0 0 0 1px rgba(255, 255, 255, 0.6)",
      }}
    >
      {(title || action) && (
        <div
          className={cn(
            "flex items-center justify-between px-6 py-4 border-b border-slate-100/80",
            gradientHeader && "bg-gradient-to-r from-brand-500/5 to-indigo-500/5"
          )}
        >
          <div>
            {title && <h3 className="font-bold text-slate-800">{title}</h3>}
            {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      <div className={cn("p-6", (title || action) && "p-6")}>{children}</div>
    </div>
  );
}
